import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, Home } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useApp } from '../context/AppContext';

const AccessRestricted = () => {
  const { currentRole } = useApp();

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="access-restricted">
      <Card className="bg-white border-slate-200 shadow-lg max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-amber-50 flex items-center justify-center">
            <ShieldAlert className="h-8 w-8 text-amber-600" />
          </div>
          
          <h1 className="text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
            Access Restricted
          </h1>
          
          <p className="text-slate-600 mb-6">
            Your current role <span className="font-semibold text-slate-800">({currentRole.name})</span> does not have permission to access this page.
          </p>
          
          <div className="space-y-3">
            <Link to="/">
              <Button className="w-full bg-[#fd4816] hover:bg-[#ea380c] text-white">
                <Home className="h-4 w-4 mr-2" />
                Go to Dashboard
              </Button>
            </Link>
            
            <Button
              variant="outline"
              className="w-full border-slate-200 text-slate-700 hover:bg-slate-50"
              onClick={() => window.history.back()}
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go Back
            </Button>
          </div>
          
          <p className="text-xs text-slate-500 mt-6">
            If you believe you should have access, please contact your system administrator or switch to a different role with the appropriate permissions.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessRestricted;
